import { ITreeNode } from "blick.react.utils";
import { Device } from "../../shared/generated";

export enum TreeTableType {
    BlockedDevices,
    BannedDevices,
    ElapsingPayment
}
export interface ITreeTableRow {
    client: string;
    account: string;
    device: Device;
}
export const getTreeTableWithProperty = (data: { [key: string]: { [key: string]: Device[]; }; }, treeTableType: TreeTableType, expandedKeys: string[]) => {
    let clientsCounter = 0;
    let index = 0;
    const treeTable: ITreeNode<ITreeTableRow>[] = [];

    Object.entries(data).forEach(([client, accounts]) => {
        const clientNode: ITreeNode<ITreeTableRow> = {
            key: clientsCounter.toString(),
            label: client,
            index: index,
            value: client,
            data: null as unknown as ITreeTableRow
        }

        index++;
        let accountsCounter = 0;
        expandedKeys.push(clientNode.key);

        Object.entries(accounts).forEach(([account, devices]) => {
            const accountNode: ITreeNode<ITreeTableRow> = {
                key: clientNode.key + "-" + accountsCounter,
                label: account,
                index: index,
                value: account,
                data: null as unknown as ITreeTableRow
            }

            index++;
            expandedKeys.push(accountNode.key);

            let devicesCounter = 0;
            devices.forEach(device => {
                if (!useDeviceProp(device, treeTableType))
                    return;

                if (!accountNode.children)
                    accountNode.children = [];

                accountNode.children.push({
                    key: accountNode.key + "-" + devicesCounter,
                    label: device.DeviceModelName + " " + device.Serial,
                    data: { device: device, account: account, client: client },
                    index: index,
                    value: device.Serial || "",
                })
                index++;

                devicesCounter++;
            });

            if (!clientNode.children)
                clientNode.children = [];

            if (accountNode.children?.length && accountNode.children.length > 0)
                clientNode.children.push(accountNode);

            accountsCounter++;
        })
        if (clientNode.children?.length && clientNode.children.length > 0)
            treeTable.push(clientNode);

        clientsCounter++;
    })
    return treeTable;
}
const useDeviceProp = (device: Device, treeTableType: TreeTableType) => {
    switch (treeTableType) {
        case TreeTableType.BannedDevices:
            return device.Banned;
        case TreeTableType.BlockedDevices:
            return device.Blocked;
        case TreeTableType.ElapsingPayment:
            return !device.Blocked && !device.Banned && (device.Balance - 14 * device.Charge < 0);
        default:
            return false;
    }
}